import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { appendQuery } from '../../shared/utils/commenFunctions';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProgramService {
  private readonly apiService = inject(ApiService);
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.host;
  private readonly programHost =
    (environment as { programHost?: string }).programHost ?? environment.host;
  /**
   * Fetches the list of users from the API
   * @returns Observable containing the user list
   */
  getPrograms(payload: Record<string, unknown> = {}): Observable<any> {
    const url = appendQuery(`${this.programHost}/api${API_ENDPOINTS.PROGRAMS.LIST}`, payload);
    return this.http.get<any>(url);
  }

  getProgramById(id: string | number): Observable<any> {
    const url = `${this.programHost}/api/program/${id}`;
    return this.http.get<any>(url);
  }
}

